module.exports = __webpack_public_path__ + "cde98ca122503b18d026e3d1f64b86e0.MP3";